import _extends from "@babel/runtime/helpers/extends";
import _jsx from "@babel/runtime/helpers/jsx";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["className", "expander", "children", "width", "styled", "loading"];
var _dec, _dec2, _class, _class2;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import withWidth, { isWidthUp } from 'muiCompat/withWidth';
import Toolbar from '@mui/material/Toolbar';
import Collapse from '@mui/material/Collapse';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import s from './Container.scss';
var ToolbarContainer = (_dec = withWidth(), _dec2 = withStyles(s), _dec(_class = _dec2(_class = (_class2 = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ToolbarContainer, _React$PureComponent);
  var _super = _createSuper(ToolbarContainer);
  function ToolbarContainer() {
    var _this;
    _classCallCheck(this, ToolbarContainer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isExpanderOpen: false
    });
    _defineProperty(_assertThisInitialized(_this), "toggleExpander", function () {
      _this.setState(function (prevState) {
        return {
          isExpanderOpen: !prevState.isExpanderOpen
        };
      });
    });
    return _this;
  }
  _createClass(ToolbarContainer, [{
    key: "render",
    value: function render() {
      var _classNames;
      var _this$props = this.props,
        className = _this$props.className,
        expander = _this$props.expander,
        children = _this$props.children,
        width = _this$props.width,
        styled = _this$props.styled,
        loading = _this$props.loading,
        rest = _objectWithoutProperties(_this$props, _excluded);
      var isExpanderOpen = this.state.isExpanderOpen;
      return /*#__PURE__*/React.createElement(Toolbar, _extends({
        className: classNames(s.toolbar, className, (_classNames = {}, _defineProperty(_classNames, s.toolbarNew, styled), _defineProperty(_classNames, s.loading, loading), _classNames))
      }, rest), expander && children && width && !isWidthUp('sm', width) ? /*#__PURE__*/_jsx(Collapse, {
        className: s.collapser,
        "in": isExpanderOpen,
        collapsedSize: "20px"
      }, void 0, /*#__PURE__*/_jsx("button", {
        "data-test-id": "bRzyvy8wFLQ19UDgggclt",
        className: s.collapseBtn,
        type: "submit",
        onClick: this.toggleExpander
      }, void 0, isExpanderOpen ? 'Close' : 'Open', " actions"), children) : children);
    }
  }]);
  return ToolbarContainer;
}(React.PureComponent), _defineProperty(_class2, "defaultProps", {
  styled: false,
  children: null,
  className: '',
  expander: false,
  width: '',
  loading: false
}), _class2)) || _class) || _class);
export { ToolbarContainer as default };